<!-- One column at the processing modal's width, so custodial and self-custody users see the same card. -->
<div class="modal-dialog modal-dialog-centered">
    <div class="modal-content my-3">
        <div class="modal-body p-0">
            <div class="cm">
                <div class="cm-main">
                    <!-- Header: review step = the action to review + close; afterwards = the action and where it is. -->
                    <div class="cm-head" *ngIf="!isDataLoaded">
                        <h4>{{reviewTitle | uiTerminology}}</h4>
                        <button type="button" class="btn-close" aria-label="Close" (click)="emitCloseModal()"></button>
                    </div>
                    <div class="cm-head" *ngIf="isDataLoaded">
                        <h4>{{headerTitle | uiTerminology}}</h4>
                        <span class="cm-head__status" *ngIf="stepStatusLabel"
                            [class.is-done]="stepStatusLabel === 'Done.'"
                            [class.is-failed]="stepStatusLabel === 'Failed.'">{{stepStatusLabel}}</span>
                    </div>

                    <div class="cm-body">
                        <div class="cm-review" *ngIf="!isDataLoaded"
                            [innerHTML]="((confirmationData.heading_content || confirmationData.content) | uiTerminology:'html') | safeHtml"></div>

                        <!-- Assets: picture, name, collection · location, category. -->
                        <div class="cm-assets" *ngIf="confirmationData?.image?.length">
                            <div class="cm-asset" *ngFor="let asset of confirmationData?.image; let i = index">
                                <div class="cm-asset__thumb">
                                    <img [src]="(asset?.image?.displayImage) | pinataThumbnail: 320"
                                        appImageFallback alt="asset" (load)="imageLoading = false" class="img-fluid">
                                </div>
                                <div class="cm-asset__text">
                                    <span class="cm-asset__name">{{withStop(assetSummaries[i]?.name || asset?.image?.name)}}</span>
                                    <span class="cm-asset__meta" *ngIf="assetSummaries[i]?.collection || assetSummaries[i]?.location">
                                        {{withStop(assetSummaries[i].collection)}}<ng-container *ngIf="assetSummaries[i].collection && assetSummaries[i].location"> · </ng-container>{{assetSummaries[i].location}}
                                    </span>
                                </div>
                                <span class="cm-asset__chip" *ngIf="assetSummaries[i]?.category">{{withStop(assetSummaries[i].category)}}</span>
                            </div>
                        </div>

                        <!-- The terms being confirmed, in the same panel the processing modal uses for its details. -->
                        <div class="cm-details" *ngIf="hasTerms && termRows.length">
                            <div class="cm-details__heading" *ngIf="termsHeading">{{termsHeading}}</div>
                            <div class="cm-rows">
                                <div class="cm-row" *ngFor="let row of termRows" [class.is-total]="row.isTotal">
                                    <span>{{row.label}}</span><span class="cm-row__value">{{row.value}}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Cancel and foreclose: the details box the flow passes (what is being cancelled). -->
                        <div class="cm-details" *ngIf="hasDetails">
                            <div class="cm-details__heading">{{progressData.details.heading | uiTerminology}}</div>
                            <div class="cm-rows">
                                <div class="cm-row" *ngFor="let row of progressData.details.rows" [class.is-total]="row.isTotal">
                                    <span>{{row.label | uiTerminology}}</span><span class="cm-row__value">{{row.value}}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Steps. Status: 0 pending, 1 in progress, 2 done, 3 failed. -->
                        <div class="cm-steps" *ngIf="isDataLoaded && progressData?.steps?.length">
                            <div class="cm-step" *ngFor="let step of progressData?.steps"
                                [class.is-pending]="step.status === 0" [class.is-active]="step.status === 1"
                                [class.is-done]="step.status === 2" [class.is-failed]="step.status === 3">
                                <h3>{{step.title | uiTerminology}}</h3>
                                <div class="cm-step__status">
                                    <span *ngIf="step.status === 0" class="cm-step__ring" aria-label="Pending"></span>
                                    <span *ngIf="step.status === 1" class="cm-step__spinner" aria-label="In progress"></span>
                                    <em *ngIf="step.status === 2" class="bi bi-check2 cm-step__done" aria-label="Done"></em>
                                    <em *ngIf="step.status === 3" class="bi bi-exclamation-triangle cm-step__failed" aria-label="Failed"></em>
                                </div>
                            </div>
                        </div>

                        <!-- Fees, or placeholders while they load. -->
                        <div class="cm-fees" *ngIf="!allStepsCompleted() && (progressData?.platformFeeDetails?.length || confirmationData?.platformFeeDetails?.length); else showFeeDetailsShimmer">
                            <div class="cm-fees__row" *ngFor="let data of progressData?.platformFeeDetails || confirmationData?.platformFeeDetails">
                                <span>{{data.title}} {{ data.value }}</span>
                                <span class="cm-fees__amount">{{data.totalDeductAmount}}</span>
                            </div>
                        </div>
                        <ng-template #showFeeDetailsShimmer>
                            <div *ngIf="!progressData?.failed">
                                <div *ngIf="isDataLoaded && !progressData?.platformFeeDetails && !allStepsCompleted() && !progressData?.isFeeExcluded" class="cm-fees">
                                    <ul class="shimmer-list">
                                        <li *ngFor="let i of [1,2,3]">
                                            <div class="shimmer-title shimmer"></div>
                                            <div class="shimmer-amount shimmer"></div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </ng-template>

                        <!-- Custodial: the platform completes the steps; the note holds the countdown. -->
                        <ng-container *ngIf="showCustodyNote">
                            <div class="cm-note" *ngIf="!countdownEnded; else custodySlow">
                                <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M12 3l7 3v5c0 4.5-3 8.3-7 10-4-1.7-7-5.5-7-10V6l7-3z" />
                                    <path d="M9 12l2 2 4-4" />
                                </svg>
                                <p>We are completing each step from your custody account. No wallet approval is needed.</p>
                                <span class="cm-note__clock">{{ minutes }}:{{ seconds }}</span>
                            </div>
                            <ng-template #custodySlow>
                                <div class="cm-note cm-note--slow fade-in-text" role="status">
                                    <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                        stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                        <circle cx="12" cy="12" r="9" />
                                        <path d="M12 7v5l3 2" />
                                    </svg>
                                    <p>This is taking longer than usual. Please keep this window open; we are still working on it.</p>
                                </div>
                            </ng-template>
                        </ng-container>

                        <!-- Self-custody users who reach this modal (the cart) sign in their own wallet. -->
                        <div class="cm-note" *ngIf="showWalletNote">
                            <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M20 7H5a2 2 0 0 1 0-4h13v4" />
                                <path d="M3 5v14a2 2 0 0 0 2 2h15V7" />
                                <path d="M16 14h.01" />
                            </svg>
                            <p>Confirm each request in your wallet as it appears. Keep this window open until every step is done.</p>
                        </div>

                        <!-- Success -->
                        <div class="cm-success" *ngIf="allStepsCompleted()">
                            <span class="cm-success__tick" aria-hidden="true"><em class="bi bi-check2"></em></span>
                            <h4 [innerHTML]="(progressData?.successTitle | uiTerminology:'html') | safeHtml"></h4>
                        </div>
                        <div *ngIf="this.progressData?.currentStep === progressData?.steps?.length && allStepsCompleted()">
                            <div class="cm-message" [innerHTML]="(progressData?.successMessage | uiTerminology:'html') | safeHtml"></div>
                        </div>

                        <!-- Failed -->
                        <p class="cm-message cm-message--failed" *ngIf="isFailed && isDataLoaded">
                            This step did not complete. Close this window and try again; if it keeps failing, contact support.
                        </p>

                        <!-- Footer: review step = fee note + Confirm; afterwards = Okay once finished. -->
                        <div class="cm-actions">
                            <p class="cm-footnote" *ngIf="!isDataLoaded && confirmationData.footer_content">({{ confirmationData.footer_content }})</p>
                            <p class="cm-footnote text-danger" *ngIf="hasInactiveItems">
                                Please remove inactive assets before proceeding with the purchase.
                            </p>
                            <button *ngIf="!isDataLoaded" class="cm-btn" type="button" (click)="onConfirm()"
                                [disabled]="hasInactiveItems || isConfirming">
                                Confirm.
                            </button>
                            <!-- this is for reference purpose for previous flow  =  progressData?.failed || (progressData?.currentStep === progressData?.steps?.length && (progressData?.steps[this.progressData?.currentStep - 1]?.status === 2 || progressData?.steps[this.progressData?.currentStep - 1]?.status === 3)) && !progressData?.showButton -->
                            <button *ngIf="(progressData?.failed || allStepsCompleted()) && !progressData?.showEstimation"
                                class="cm-btn" type="button" (click)="emitCloseModal()">Okay.</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

